var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 34,
    viewBox: "0 0 65 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0981445,
    y: 0.58252,
    width: 64,
    height: 33,
    rx: 16.5,
    fill: "#DADADA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8475 10.0113C24.457 9.62099 23.8239 9.62086 23.4335 10.0113L17.0692 16.3755C16.679 16.766 16.679 17.3991 17.0692 17.7896L23.4335 24.1538C23.8239 24.5442 24.457 24.5441 24.8475 24.1538C25.238 23.7633 25.238 23.1303 24.8475 22.7398L20.1913 18.0825L46.4198 18.0825C46.9721 18.0825 47.4198 17.6348 47.4198 17.0825C47.4198 16.5303 46.9721 16.0825 46.4198 16.0825L20.1913 16.0825L24.8475 11.4253C25.238 11.0348 25.238 10.4018 24.8475 10.0113Z",
    fill: "#1B1B1B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.75349c4ef449a9daf04acecadc8803d9.svg";
export { ForwardRef as ReactComponent };